import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";
import { appBackgroundColor, appFontColor, regularFont } from "@app/styles";

const GlobalStyles = createGlobalStyle`
  ${normalize}

  * {
    box-sizing: border-box;
    margin:0;
    padding:0;
  }
 
  :root {
  --kazoobadooTeal: #00be9a;
  --textColor: #33403e;
  --white: #fff;
  --borderColor: #dfe3e9;
  }

  body {
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    ${regularFont}
    background-color: ${appBackgroundColor};
    color: ${appFontColor};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
      "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
      sans-serif;
  }  

  .primary-header-logo {
    font-family: "Filson";
    font-size: 60px;
    font-weight: 500;
    line-height: 1.25;
    color: var(--kazoobadooTeal);
    margin: 0;
    @media (max-width: 575px){
      font-size: 24px;
    }
    &.alt{
      font-size: 16px;
    }
    &.fs-18{
      font-size: 18px;
    }
    &.label-color{
      color: var(----textColor);
    }
  }

  .primary-header {
    font-family: "Filson";
    font-size: 32px;
    font-weight: 500;
    line-height: 1.25;
    color: var(--kazoobadooTeal);
    margin: 0;
    @media (max-width: 575px){
      font-size: 24px;
    }
    &.alt{
      font-size: 16px;
    }
    &.fs-18{
      font-size: 18px;
    }
    &.label-color{
      color: var(----textColor);
    }
  }
  
  .text-ellipsis{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .otp-input-holder{
    justify-content: center;
    margin-bottom: 40px;
  }

  .custom-input{
    width: 44px !important;
    height: 44px;
    background-color: #fcfcfc;
    border: 2px solid #DFE3E9;
    border-radius: 6px;
    font-size: 18px;
    font-weight: 600;
    color: var(--textColor);
  }

  .react-tel-input{
    height: 44px;
    display: flex;
    input.form-control{
      height: 44px;
      background-color: #fcfcfc;
      border: 2px solid #DFE3E9;
      border-radius: 6px;
      font-size: 14px;
      color: var(--textColor);
    }
    .flag-dropdown{
      border: 2px solid #DFE3E9;
      border-radius: 6px 0 0 6px;
    }
    .selected-flag{
      border-radius: 6px 0 0 6px;
      padding: 0 6px;
    }
  }

  .phone-input{
    input{
      position: relative;
      font-family: 'Poppins';
      &.non-editable {
        cursor: not-allowed;
        &::after {
          content: "";
          background: rgb(236 236 236 / 50%);
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 6px;
        }
      }
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 6px;
  } 

  ::-webkit-scrollbar-thumb {
    background: rgb(0,0,0, 0.6);
    border-radius: 6px;
  }

  @media (max-width: 575px){
    .dropdown-menu{
      transform: unset !important;
      top: 70px !important;
      width: 100% !important;
      margin: 0 !important;
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
      &::before, &:after{
        display: none !important;
      }
    }
  }

`;

export default GlobalStyles;
